export default __webpack_public_path__ + "static/media/products_122.2bba46a9.jpg";